import {isString} from 'lodash';

export default function dedupeMapboxStyleSources(style: mapboxgl.Style) {

    const groups: {[json: string]: string} = {};
    const duplicateSources: {[id: string]: string} = {};

    if ('sources' in style) {
        for (const id in style.sources!) {
            const source = style.sources![id];
            const key = JSON.stringify(source);

            if (!groups[key] || source.type !== 'vector') {
                groups[key] = id;
            } else {
                duplicateSources[id] = groups[key];
            }
        }
    }

    return {
        ...style,
        layers: style.layers && style.layers.map(layer => ({
            ...layer,
            ...isString(layer.source) && duplicateSources[layer.source] && {
                source: duplicateSources[layer.source]
            }
        }))
    };

}
